import * as React from 'react';
import { LightBackgroundView } from './Themed';

export default function Separator() {
    return <LightBackgroundView style={{ height: 1 }} />
}